import { AutogenModelTopmatchRoutingGuides, AutogenRowTopmatchRoutingGuides } from "./autogen/AutogenModelTopmatchRoutingGuides";

export class ModelTopmatchRoutingGuides extends AutogenModelTopmatchRoutingGuides<RowTopmatchRoutingGuides> {
    constructor() {
        super(RowTopmatchRoutingGuides);
    }
}

export class RowTopmatchRoutingGuides extends AutogenRowTopmatchRoutingGuides {
}